import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { findIcon } from "../../../../dashboard/icons";
import ContentListingCard from "../components/ContentListingCard";
import ReactTable from "../../../../../lib/table/react-table";
import SparlLineBar from "../../../../../components/chart/SparlLineBar";
import { Link, useParams } from "react-router-dom";
import useRedirect from "../../../../../components/custom-hooks/use-redirect";
import {
  useGetCreativeDataList,
  useGetCreativeDataListBQ,
  useGetCreativeDataListCTA,
} from "../../../../../queries/query-hooks/workspace/sponsored-content-hook";
import useCsvDownloader from "../../../../../components/custom-hooks/use-csv-downloader";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import Skeleton from "../../../../../components/skeleton";
import ImageWithFallback from "../../../../../components/ImageWithFallback";
import { fallbackImages } from "../../../../../common/constants/fallback-images";
import {
  downloadTablePNG,
  formatLocalizedDate,
  getFormatedDate,
  openInNewTab,
} from "../../../../../common/utils/utils";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import { checkProjectAccess } from "../utils/common";
import dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader, CardNotFound } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";

function Content() {
  const { redirectTo } = useRedirect();
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { downloadCSV } = useCsvDownloader();

  const [tableColumnData, setTableColumnData] = useState([]);
  const [isListView, setIsListView] = useState(true);

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  const { data: creativeDataList, isLoading: isCreativeDataListLoading } =
    useGetCreativeDataList(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: creativeDataListBQ, isLoading: isCreativeDataBQListLoading } =
    useGetCreativeDataListBQ(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        content_id:
          creativeDataList &&
          Array.isArray(creativeDataList) &&
          creativeDataList.length > 0
            ? creativeDataList.map((item) => item.content_id).join(",")
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const { data: creativeDataListcta, isLoading: isCreativeDataCTAListLoading } =
    useGetCreativeDataListCTA(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        content_id:
          creativeDataList &&
          Array.isArray(creativeDataList) &&
          creativeDataList.length > 0
            ? creativeDataList.map((item) => item.content_id).join(",")
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  function mergeContentData(data1, data2, data3) {
    data1 = Array.isArray(data1) ? data1 : [];
    data2 = Array.isArray(data2) ? data2 : [];
    data3 = Array.isArray(data3) ? data3 : [];
    const data2Map = new Map(data2.map((item) => [item.type_id, item]));
    const data3Map = new Map(
      data3.map((item) => [item.name || item.content_id, item])
    );
    const allKeys = new Set([
      ...data1.flatMap(Object.keys),
      ...data2.flatMap(Object.keys),
      ...data3.flatMap(Object.keys),
    ]);
    let mergedData = data1.map((item) => {
      const match2 = data2Map.get(
        item?.fetch_with_contents_list?.at(0).content_old_id
      );
      const match3 = data3Map.get(
        item?.fetch_with_contents_list?.at(0).content_old_id
      );
      const mergedItem = { ...item };

      allKeys.forEach((key) => {
        if (!(key in mergedItem)) {
          if (match2 && key in match2) {
            mergedItem[key] = match2[key];
          } else if (match3 && key in match3) {
            mergedItem[key] = match3[key];
          } else {
            mergedItem[key] = "N/A";
          }
        }
      });

      return mergedItem;
    });
    const addMissingItems = (dataArray, dataMap) => {
      dataArray.forEach((item) => {
        const itemName = item.name || item.state_name;
        if (!mergedData.some((mergedItem) => mergedItem.name === itemName)) {
          const newItem = { name: itemName };
          allKeys.forEach((key) => {
            newItem[key] = key in item ? item[key] : "N/A";
          });
          mergedData.push(newItem);
        }
      });
    };
    addMissingItems(data2, data2Map);
    addMissingItems(data3, data3Map);

    return mergedData;
  }
  const contentListData = mergeContentData(
    creativeDataList,
    creativeDataListBQ,
    creativeDataListcta
  );

  const handleTableCsvDownload = () => {
    downloadCSV(tableCsvFormat);
  };
  const tableRef = useRef();

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  const formatDataforExport = (data) => {
    return data.map((item) => {
      return {
        ...item,
        thumbnail:
          item?.fetch_with_contents_list[0]?.content_image_data[0]
            ?.content_image_data?.base,

        content_title: item?.fetch_with_contents_list[0]?.content_title,

        content_category:
          item?.fetch_with_contents_list[0]?.content_category
            ?.content_category_name,

        speciality:
          item?.fetch_with_contents_list[0]?.content_speciality[0]
            ?.master_speciality?.speciality_name,

        views: item?.views,
        reads: item?.reads,

        cta: item?.cta,
      };
    });
  };

  const tableCsvFormat = {
    header: [
      "Thumbnail",
      "Content Title",
      "Content Category",
      "Speciality",
      "Viewed",
      "Reads",
      "CTA's",
    ],
    column: [
      "thumbnail",
      "content_title",
      "content_category",
      "speciality",
      "views",
      "reads",
      "cta",
    ],
    rows: formatDataforExport(contentListData),
  };

  const hasViewAccess = checkProjectAccess("show_view", projectDetails);
  const hasReadAccess = checkProjectAccess("show_read", projectDetails);
  const hasCTAAccess = checkProjectAccess("show_CTA", projectDetails);

  useEffect(() => {
    let columns = [
      {
        Header: "Thumbnail",
        columnId: 1,
        accessor:
          "fetch_with_contents_list[0].content_image_data[0].content_image_data",
        disableFilters: true,
        Cell: ({ value, row }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return (
              <>
                <ImageWithFallback
                  onClick={() => openInNewTab(value.base)}
                  src={value.thumbnail}
                  fallbackSrc={fallbackImages.noImage}
                  className="rounded-3 border border-1 icon-60 cursor-pointer"
                />
              </>
            );
          }
        },
      },
      {
        Header: "Content Title",
        columnId: 2,
        accessor: "fetch_with_contents_list[0]",
        disableFilters: true,
        width: 300,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return (
              <div
                style={{ maxWidth: "20rem" }}
                className="text-truncate"
                title={value?.content_title}
              >
                <Link
                  to={`/sponsored-content/${project_id}/content/details/${value?.content_id}`}
                  className="text-black "
                >
                  {value?.content_title}
                </Link>
              </div>
            );
          }
        },
      },
      {
        Header: "Content Category",
        columnId: 3,
        accessor:
          "fetch_with_contents_list[0].content_category.content_category_name",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return value;
          }
        },
      },
      {
        Header: "Speciality",
        columnId: 4,
        accessor:
          "fetch_with_contents_list[0].content_speciality[0].master_speciality.speciality_name",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return value;
          }
        },
      },
    ];

    if (hasViewAccess) {
      columns.push({
        Header: "Viewed",
        columnId: 5,
        accessor: "views",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return value;
          }
        },
      });
    }

    if (hasReadAccess) {
      columns.push({
        Header: "Reads",
        columnId: 6,
        accessor: "reads",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return value;
          }
        },
      });
    }

    if (hasCTAAccess) {
      columns.push({
        Header: "CTA",
        columnId: 7,
        accessor: "user_count",
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          if (value === -1) {
            return <Skeleton variant="text" width={100} height={20} />;
          } else if (value == undefined || value == null) {
            return "N/A";
          } else {
            return value;
          }
        },
      });
    }

    // columns.push({
    //   Header: "Trends",
    //   columnId: 8,
    //   accessor: "date_Data",
    //   disableFilters: true,
    //   Cell: ({ cell: { value } }) => {
    //     if (value === -1) {
    //       return <Skeleton variant="text" width={100} height={20} />;
    //     } else if (value == undefined || value == null) {
    //       return "N/A";
    //     } else if (value === "N/A") {
    //       return value;
    //     } else {
    //       return (
    //         <SparlLineBar
    //           series={value && value?.length > 0 ? value.split(",") : []}
    //           labels={[]}
    //           height={50}
    //         />
    //       );
    //     }
    //   },
    // });

    setTableColumnData(columns);
  }, [hasViewAccess, hasReadAccess, hasCTAAccess]);

  return (
    <>
      <Row>
        <Col md={12} className="mb-2">
          {!isProjectDetailsLoading && (
            <ProjectHeaderTopBar
              projectType="Sponsored Content"
              title="Content"
              projectStartDate={projectDetails[0]?.project_start_date || ""}
              projectEndDate={projectDetails[0]?.project_end_date || ""}
              isProjectDetailsLoading={isProjectDetailsLoading}
              rightComponent={
                <ProjectFilters
                  itle="Content"
                  setDateRangePayload={setDateRangePayload}
                  projectStartDate={projectDetails[0]?.project_start_date || ""}
                  projectEndDate={projectDetails[0]?.project_end_date || ""}
                  dateLabel={dateRangePayload}
                  showListView={true}
                  setIsListView={setIsListView}
                  isListView={isListView}
                />
              }
            />
          )}
        </Col>

        <Col md={12}>
          {isListView && !isProjectDetailsLoading && (
            <>
              <Col md={12} sm={12} className="pe-0">
                <Card>
                  <TableHeader
                    downloadProps={{
                      needCsvDownload:
                        !isCreativeDataListLoading &&
                        creativeDataList?.length > 0,
                      needImgDownload:
                        !isCreativeDataListLoading &&
                        creativeDataList?.length > 0,
                      exportCSVHandler: handleTableCsvDownload,
                      downloadImageHandler: () => downloadTablePNG(tableRef),
                    }}
                    alignmentEnd={true}
                  />

                  <Card.Body>
                    {!isCreativeDataListLoading &&
                    !isCreativeDataBQListLoading &&
                    !isCreativeDataCTAListLoading &&
                    creativeDataList.length > 0 &&
                    tableColumnData.length > 0 ? (
                      <div ref={tableRef}>
                        <ReactTable
                          data={contentListData}
                          columns={tableColumnData}
                          isPaginationShow={false}
                          bordered
                          noDataText="no data"
                          noDataImage={fallbackImages.noActionData}
                        />
                      </div>
                    ) : isCreativeDataListLoading ||
                      isCreativeDataBQListLoading ||
                      isCreativeDataCTAListLoading ||
                      tableColumnData.length === 0 ? (
                      <CommonTableLoader tableRowLength={5} />
                    ) : (
                      <CardNotFound />
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </>
          )}

          {!isProjectDetailsLoading &&
            !isListView &&
            !isCreativeDataListLoading &&
            contentListData?.length > 0 && (
              <>
                <TableHeader
                  cardHeaderClass="align-items-sm-center align-items-start gap-2 pb-0 px-0"
                  title="Content"
                  searchProps={{
                    isNeeded: true,
                    placeholder: "Search for content",
                    searchText: searchText,
                    setSearchText: setSearchText,
                  }}
                  downloadProps={{
                    needCsvDownload:
                      !isProjectDetailsLoading &&
                      !isListView &&
                      !isCreativeDataListLoading &&
                      contentListData?.length > 0,
                    needImgDownload:
                      !isProjectDetailsLoading &&
                      !isListView &&
                      !isCreativeDataListLoading &&
                      contentListData?.length > 0,
                    exportCSVHandler: handleTableCsvDownload,
                    downloadImageHandler: () => downloadTablePNG(tableRef),
                  }}
                />
                <div className="row mt-3" ref={tableRef}>
                  {contentListData
                    ?.filter((item) =>
                      item?.fetch_with_contents_list[0]?.content_title
                        ?.toLowerCase()
                        ?.includes(searchText?.toLowerCase())
                    )
                    ?.map((item) => (
                      <Col key={item.content_id} md={4} sm={6} lg={3}>
                        <ContentListingCard
                          contentTags={
                            item?.fetch_with_contents_list[0]?.content_tags &&
                            Array.isArray(
                              item?.fetch_with_contents_list[0]?.content_tags
                            )
                              ? item?.fetch_with_contents_list[0]?.content_tags?.map(
                                  (item) => {
                                    return {
                                      name: item?.tag_data?.content_tag_name,
                                    };
                                  }
                                )
                              : []
                          }
                          contentDate={getFormatedDate(
                            item?.fetch_with_contents_list[0]?.created_at
                          )}
                          contentTitle={
                            item?.fetch_with_contents_list[0]?.content_title
                          }
                          contentReads={item?.reads}
                          contentViews={item?.views}
                          contentType={
                            item?.fetch_with_contents_list[0]?.content_category
                              .content_category_name
                          }
                          contentLogo={
                            item?.fetch_with_contents_list[0]?.content_category
                              .content_category_icon
                          }
                          contentImage={
                            item?.fetch_with_contents_list[0]
                              ?.content_image_data[0]?.content_image_data?.base
                          }
                          fallbackContentImage={fallbackImages?.noImage}
                          contentId={item?.content_id}
                        />
                      </Col>
                    ))}
                </div>
              </>
            )}
        </Col>
      </Row>
    </>
  );
}

export default Content;
